import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { auth } from './modules/auth'
import { user } from './modules/user'
import { businesstype } from './modules/businesstype'
import { category } from './modules/category'
import { categorycon } from './modules/categorycon'
import { commitment } from './modules/commitment'
import { kpi } from './modules/kpi'
import { kpicon } from './modules/kpi_con'
import { managment } from './modules/managment'
import { meeting } from './modules/meeting'
import { meetingtype } from './modules/meetingtype'
import { objective } from './modules/objective'
import { personalcommitments } from './modules/personalcommitments'
import { personaldevelopment } from './modules/personal_development'
import { personaldevelopmentcon } from './modules/personal_development_con' 
import { plan } from './modules/plan'
import { plan_con } from './modules/plan_con'
import { plan_lider} from './modules/plan_lider'
import { profile } from './modules/profile'
import { State } from './modules/state'
import { subcategory } from './modules/subcategory'
import { subcategorycon } from './modules/subcategorycon'
import { team } from './modules/team'
import { tracing } from './modules/tracing'
import { travel } from './modules/travel'
import { segment } from './modules/segment'
import { product } from './modules/product'
import { problem } from './modules/problem'
import { schedule } from './modules/schedule'
import { consultant } from './modules/consultant'
import { weeklychallenge } from './modules/weekly_challenge'
import { weeklychallengecon } from './modules/weekly_challenge_con'
import { guidelinecomment } from './modules/guideline_comment'
import { typeimpediment } from './modules/typeimpediments'
import { role } from './modules/role'
import { comments_plancon } from './modules/comments_plancon'
import { monthlypc } from './modules/monthlypc'
import { session } from './modules/session'
import { scalevalues } from './modules/scale_value'
import { kpiexterno } from './modules/kpi_externo'
import { categoryext } from './modules/categoryext'
import { guideline } from './modules/guideline'
import { contractor } from  './modules/contractor'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],

  modules: {
    auth,
    user,
    businesstype,
    category,
    categorycon,
    commitment,
    kpi,
    kpicon,
    managment,
    meeting,
    meetingtype,
    objective,
    personalcommitments,
    personaldevelopment,
    personaldevelopmentcon,
    plan,
    plan_con,
    plan_lider,
    profile,
    State,
    subcategory,
    subcategorycon,
    team,
    tracing,
    travel,
    segment,
    product,
    problem,
    schedule,
    consultant,
    weeklychallenge,
    weeklychallengecon,
    guidelinecomment,
    typeimpediment,
    role,
    comments_plancon,
    monthlypc,
    session,
    scalevalues,
    kpiexterno,
    categoryext,
    guideline,
    contractor
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js